import { TODAY } from '../../constants';
import type { Phase } from '../../types/domain';
import { currentContractYear, isoStr, type ContractYear } from '../dates';
import { toNumber } from '../numbers';
import type { HoursByDayAndDev } from '../planning/types';
import { marginData } from './margin';
import type { HourlyCosts, PhaseMarginData } from './types';

/* Marge d'une maintenance sur l'année de contrat en cours (arbitrage du 02/10/2026, affichée à
   côté de la marge à date) : vendu = mensuel × mois de la période (12, ou moins si le contrat
   finit avant) ; coût = heures passées depuis le début de la période × coût horaire. */
export function maintenanceYearMargin(
  phase: Phase,
  daily: HoursByDayAndDev | null | undefined,
  costMap: HourlyCosts,
  todayIso: string = isoStr(TODAY),
): (PhaseMarginData & ContractYear) | null {
  const year = currentContractYear(phase.dateDebut, phase.dateFin, todayIso);
  if (!year) return null;
  const until = year.to < todayIso ? year.to : todayIso;
  let heures = 0,
    cout = 0;
  for (const [date, byDev] of Object.entries(daily || {})) {
    if (date < year.from || date > until) continue;
    for (const [devId, h] of Object.entries(byDev)) {
      heures += h;
      cout += h * (costMap[devId] || 0);
    }
  }
  const vendu = toNumber(phase.montantGlobal || 0) * year.months;
  return { ...year, ...marginData(vendu, cout, heures) };
}
